import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/demand/partners')({
  component: DemandPartnersLayout,
});

function DemandPartnersLayout() {
  return <Outlet />;
}
